import React from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import Complete from '@bizapp-lp/workflow/templates/Complete';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    lineBreaks: {
      display: 'block',
    },
  }),
);

type CompleteTrialApplicationState = {
  valid?: boolean;
};

export interface CompleteTrialApplicationProps {
  isAllowedDirectAccess?: boolean;
}
const title =
  'Workflow お問い合わせ | ノーコードで現場で簡単に利用することができるワークフローサービス';
const description =
  '株式会社ワークスアプリケーションズ・エンタープライズがご提供する、Workflow 無料トライアルお申し込み完了ページです。';

const CompleteTrialApplication: React.FC<CompleteTrialApplicationProps> = ({
  isAllowedDirectAccess,
}) => {
  const classes = useStyle();
  const { state } = useLocation() as { state: CompleteTrialApplicationState };
  return isAllowedDirectAccess || state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="無料トライアルのお申し込み"
        heading2="お申し込みが完了しました"
        description={
          <>
            <span className={classes.lineBreaks}>
              お問い合わせいただき、ありがとうございました。{' '}
            </span>
            <span className={classes.lineBreaks}>
              確認のためお客様へ自動返信メールをお送りしております。
            </span>
            <span className={classes.lineBreaks}>
              弊社担当よりご連絡いたしますので、今しばらくお待ちください。
            </span>
          </>
        }
      />
    </>
  ) : (
    <Navigate to="/workflow/invalid" replace />
  );
};

export default CompleteTrialApplication;
